export default "__VITE_ASSET__BkCCl_Pv__"